import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { mixpanelTrack } from 'src/utils/analytics';

const getPageName = (pathname: string) => {
  if (pathname === '/reports') return 'Reports Page';
  if (pathname.includes('/lists/')) return 'List Builder';
  if (pathname.includes('/messaging/')) return 'Message Builder';
  return null;
};

export default function PageTracker() {
  const location = useLocation();
  const [prevPage, setPrevPage] = useState('');
  const [startTime, setStartTime] = useState(new Date());

  useEffect(() => {
    const endTime = new Date();

    if (location.pathname !== prevPage && endTime.getTime() - startTime.getTime() < 3600000) {
      const pageName = getPageName(prevPage);
      if (pageName) {
        mixpanelTrack('Time on ' + pageName, {
          time_ms: endTime.getTime() - startTime.getTime(),
        });
      }
    }
    setPrevPage(location.pathname);
    setStartTime(endTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
}
